import { useAdvisorDetailQuery } from "web_myplann/Api/Advisor/useAdvisorDetailQuery";
import { useChatConversationQuery } from "web_myplann/Api/Chat/useChatConversationQuery";
import { getConversationName } from "web_myplann/Chat/Helpers/List/getConversationName";

export const useChatRecipient = (
	conversationId: number | null,
	advisorId?: string,
) => {
	const { data: conversation, isLoading: isConversationLoading } =
		useChatConversationQuery(conversationId);
	const { data: advisor, isLoading: isAdvisorLoading } =
		useAdvisorDetailQuery(advisorId);

	const participant = conversation?.participant;
	const conversationName = conversation
		? getConversationName(conversation)
		: "";
	const isGroup = !advisor && Boolean(conversation?.isGroup);
	const advisorName =
		advisor?.name ?? (isGroup ? participant?.name : conversationName) ?? "";
	const advisorPhoto = advisor?.avatar ?? participant?.avatar ?? undefined;

	return {
		advisorId: advisorId ?? participant?.id,
		advisorName,
		advisorPhoto,
		title: isGroup ? conversationName : advisorName,
		titlePhoto: isGroup ? undefined : advisorPhoto,
		isLoading:
			(conversationId !== null && isConversationLoading) ||
			(Boolean(advisorId) && isAdvisorLoading),
	};
};
